import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealItemSelectionEntity } from '../../domain/entities/MealItemSelectionEntity'
import { SelectionValueType } from '@/features/order/domain/enums/SelectionValueType'

export class MealItemSelectionModel extends MealItemSelectionEntity {
  declare selectionId: string
  selectionValues!: Array<{
    selectionValueId?: string
    type?: SelectionValueType
  }>
  constructor(dataDto: MealItemSelectionEntity) {
    super()
    let selectionValues = []
    const itemValues = dataDto.itemValueIds?.map((itemValueId) => ({
      selectionValueId: itemValueId,
      type: SelectionValueType.ITEM
    }))
    const simpleValues = dataDto.simpleValueIds?.map((simpleValueId) => ({
      selectionValueId: simpleValueId,
      type: SelectionValueType.SIMPLE
    }))
    selectionValues = [...(itemValues || []), ...(simpleValues || [])]
    mapEntityProperties<MealItemSelectionModel>(this, dataDto, {
      exclude: ['simpleValueIds', 'itemValueIds'],
      map: {
        selectionValues: selectionValues
      }
    })
  }
}
